import { writable } from 'svelte/store'

const createDefaultStore = () => {
  const { subscribe, set, update } = writable([])
  
  return {
    subscribe,
    set,
    update
  }
} 
const createModalStore = () => {
  const { subscribe, set, update } = writable({})
  
  return {
    subscribe,
    set,
    update,
    toggle: (name, force = null) => {
      update(modals => ({...modals, [name]: force !== null ? force : !modals[name]}))
    }
  }
} 

export const locationStore = createDefaultStore()
export const clientStore = createDefaultStore()
export const userStore = createDefaultStore()
export const signatureBlockStore = createDefaultStore()
export const snackBarStore = createDefaultStore()
export const workLogStore = createDefaultStore()
export const tenantStore = createDefaultStore()
export const peopleStore = createDefaultStore()
export const modalStore = createModalStore()
